export class Index {
    id?: string;
    value?: number;
    year?: number;
    constructor(index?: Index) {
        this.id = index?.id;
        this.value = index?.value;
        this.year = index?.year;
    }

}
